module.exports = __webpack_public_path__ + "static/media/search-white.9aa17704.svg";